import "./scss/Foundation/style.scss";
import * as SCROLL_ANIMATION from "./constants/scrollAnimationConstants";
import * as DRAWER from "./constants/drawerConstants";
import * as OVERLAY from "./constants/overlayConstants";
import { DrawerListener } from "./modules/DrawerListener";
import { ScrollAnimation } from "./modules/ScrollAnimation";

const mediaQueryList: MediaQueryList = window.matchMedia(`(min-width: ${DRAWER.BREAK_POINT}px)`);
const drawerTriggers = document.getElementsByClassName(DRAWER.CLASS_NAMES.TRIGGER);
const overlay: Element | null = document.getElementsByClassName(OVERLAY.CLASS_NAMES.OVERLAY)[0];
const animationWrapper = document.getElementsByClassName(SCROLL_ANIMATION.CLASS_NAMES.WRAPPER);

document.addEventListener("DOMContentLoaded", function () {
  if (drawerTriggers && mediaQueryList) {
    for (let i = 0; i < drawerTriggers.length; i++) {
      const trigger = drawerTriggers[i];
      const listener = new DrawerListener(trigger, overlay);
      listener.listen();
    }
  }
});

window.addEventListener("load", function () {
  if (animationWrapper) {
    for (let k = 0; k < animationWrapper.length; k++) {
      const wrapper = animationWrapper[k];
      if (wrapper instanceof HTMLElement) {
        const scrollAnimation = new ScrollAnimation(wrapper);
        scrollAnimation.observe();
      }
    }
  }
});
